import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IReportModel } from '../models/IReportModel';
import { SsrsServerCommandModel } from '../models/SsrsServerCommandModel';
import { SsrsViewerCommandModel } from '../models/SsrsViewerCommandModel';
import { ActivityAction } from '../../core/store/action/ActivityAction';
import { Action, Store } from '@ngrx/store';
import { SsrsReportModel } from '../models/SsrsReportModel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'plr-ssrs-report-viewer',
  templateUrl: './ssrs-report-viewer.component.html',
  styleUrls: ['./ssrs-report-viewer.component.scss']
})
export class SsrsReportViewerComponent implements OnInit {
  loading = true;
  initialized = false;
  ssrsReportViewerId: string;
  fullReportUrl: string;
  reportModel: SsrsReportModel

  @Input()
  ssrsServerUrl: string;

  @Input()
  set report(reportModel: SsrsReportModel) {
    this.reportModel = reportModel;
    this.refresh();
  };

  @Input()
  reportServerCommands: SsrsServerCommandModel;

  @Input()
  reportViewerCommands: SsrsViewerCommandModel;

  constructor(
    private sanitizer: DomSanitizer,
    private store: Store<any>
    ) {
    this.ssrsReportViewerId = new Date().getTime().toString();
  }

  ngOnInit() {
    this.buildReportUrl();
    this.loading = false;
  }

  refresh() {
    this.initialized = false;
    this.loading = true;
    this.buildReportUrl();
    this.loading = false;
  }

  getSanitizedUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.fullReportUrl);
  }

  encodeUriQuery(val, pctEncodeSpaces = false) {
    return encodeURIComponent(val)
      .replace(/%40/gi, '@')
      .replace(/%3A/gi, ':')
      .replace(/%24/g, '$')
      .replace(/%2C/gi, ',')
      .replace(/%3B/gi, ';')
      .replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
  }

  serializeValue(value: any) {
    if (Object.prototype.toString.call(value) === '[object Date]') {
      return value.toISOString();
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return value;
  }

  forEachSorted(obj, iterator, context) {
    var keys = Object.keys(obj).sort();
    for (var i = 0; i < keys.length; i++) {
      iterator.call(context, obj[keys[i]], keys[i]);
    }
    return keys;
  }

  paramSerializer(params, prefix) {
    if (!params) {
      return'';
    }

    if (!prefix) {
      prefix = '';
    }
    var parts = [];
    this.forEachSorted(params,
      (value, key) => {
        if (value === undefined || key[0] === '$') {
          return;
        }
        if (Array.isArray(value)) {
          value.forEach(
            (v) => {
              parts.push(prefix + this.encodeUriQuery(key) + '=' + this.encodeUriQuery(this.serializeValue(v)));
            });
          if (value.length === 0) {
            parts.push(prefix + this.encodeUriQuery(key) + "=''");
          }
        } else if (value === null) {
          parts.push(prefix + this.encodeUriQuery(key) + ':isnull=true');
        } else {
          parts.push(prefix + this.encodeUriQuery(key) + '=' + this.encodeUriQuery(this.serializeValue(value)));
        }
      },
      this);

    return parts.join('&');
  }

  buildReportUrl() {

    this.fullReportUrl = this.ssrsServerUrl + '?' + this.encodeUriQuery(this.reportModel.reportPath);

    if (!this.reportServerCommands) {
      this.reportServerCommands = {
        Command: 'Render',
        Embed: true
      };
    } else {
      this.reportServerCommands.Command = 'Render';
      this.reportServerCommands.Embed = true;
    }

    if (this.reportServerCommands) {
      this.fullReportUrl += '&' + this.paramSerializer(this.reportServerCommands, 'rs:');
    }

    if (this.reportViewerCommands) {
      this.fullReportUrl += '&' + this.paramSerializer(this.reportViewerCommands, 'rc:');
    }

    this.initialized = true;

    window.addEventListener('message',
      event => {
        if ((event as any).portalHandled) {
          return;
        }
        (event as any).portalHandled = true;
        if (this.ssrsServerUrl.indexOf(event.origin) === 0) {
          this.store.dispatch(new ActivityAction());
          console.log(event.data);
          if (isJson(event.data)) {
            var data = JSON.parse(event.data);
            if (data != null) {
              if (data.target === "Popup") {
                window.open(data.href, data.title, data.options);
              } else if (data.target === "Tab") {
                window.open(data.href, "_blank", data.options);
              } else {
                window.open(data.href, data.target, data.options);
              }
            }
          }
        } else {
          return;
        }
      });

    function isJson(input) {
      try {
        JSON.parse(input);
      } catch (e) {
        return false;
      }
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/report/components/ssrs-report-viewer.component.ts